export class Breadcrumb{
    private fromUrl = '';

    constructor(public text: string, public currentUrl: string, public isBrand: boolean, public isProduct: boolean) {
        this.fromUrl = currentUrl;
    }

    navigate(name: string, index: number) {
        let pathArray = this.fromUrl.split('/');
        const cleanArray = pathArray.filter(x => x !== '')
        if(cleanArray.length < 2){
            return name;
        }
        const url =`/${cleanArray.slice(0,index).join('/').toLocaleLowerCase()}`;
        return url;
    }
}
